// src/Components/Email/QuillEmailEditor.js
import React, { useEffect, useRef, useState, useMemo } from 'react';
import ReactQuill, { Quill } from 'react-quill-new';
import QuillTableBetter from 'quill-table-better';
import 'react-quill-new/dist/quill.snow.css';
import 'quill-table-better/dist/quill-table-better.css';
import { html as beautifyHtml } from 'js-beautify';
import ResizeModule from 'quill-resize-module';
import Toolbar from '../../lib/QuillResizeToolbar';
import '../../css/quill-resize.css';
import htmlclean from 'htmlclean'

ResizeModule.Modules = {
    ...ResizeModule.Modules,
    Toolbar,
};

Quill.register('modules/resize', ResizeModule);
Quill.register('modules/resize-toolbar', Toolbar);
Quill.register({'modules/table-better': QuillTableBetter }, true);
const fontsizes =["4pt","5pt","6pt","7pt","8pt","9pt","10pt","11pt","12pt","14pt","15pt","16pt","18pt","20pt","22pt","24pt","26pt","28pt","30pt","32pt"];
const Size = Quill.import('formats/size');
const Font = Quill.import('formats/font')
Size.whitelist = fontsizes
Quill.register(Size, true);

Font.whitelist = ['serif', 'sans', 'monospace', 'cursive','helvetica','arial','calibri']
Quill.register(Font, true)


const QuillEmailEditor = ({ value = '', onChange }) => {
  const quillRef = useRef(null);
  const [showHTML, setShowHTML] = useState(false);
  const [htmlContent, setHtmlContent] = useState(value);



  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ header: 1 }, { header: 2 }, {header: 3}],
        ['bold', 'italic', 'underline', 'strike'],
        ['link', 'image'],
        [{ list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ["4pt","5pt","6pt","7pt","8pt","9pt","10pt","11pt","12pt","14pt","15pt","16pt","18pt","20pt","22pt","24pt","26pt","28pt","30pt","32pt"] }],
        [{ font: ['serif', 'sans', 'monospace', 'cursive','helvetica','arial','calibri'] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ['table-better']
      ]
    },
    clipboard: {
      matchVisual: false
    },
    table: false,
    'table-better': {
      language: 'en_US',
      menus: ['column', 'row', 'merge', 'table', 'cell', 'wrap', 'copy', 'delete'],
      toolbarTable: true
    },
    resize: {
        modules: ['Resize', 'DisplaySize', 'Toolbar'],
    },
    keyboard: {
      bindings: QuillTableBetter.keyboardBindings,
    }
  }), []);


const justUpdatedFromParent = useRef(false);

// When parent prop changes (from outside), update state
useEffect(() => {
  if (value !== htmlContent) {
    justUpdatedFromParent.current = true;
    //setHtmlContent(value);
    const quill = quillRef.current.getEditor();
    if (quill?.root.innerHTML !== htmlContent) {
      const delta = quill?.clipboard.convert({html:value})
      quill?.setContents(delta, 'silent')
    }
  }
}, [value]);

// When switching back to Quill, update its content
useEffect(() => {
  if (!showHTML && quillRef.current && justUpdatedFromParent.current) {
    const editor = quillRef.current.getEditor();
    if (editor.root.innerHTML !== htmlContent) {
      let html = htmlclean(htmlContent)
      html =htmlContent.replaceAll('<p><br></p>','<p></p>');
      editor.root.innerHTML = html;
      onChange?.(html)
      const length = editor.getLength();
      setTimeout(() =>{editor.setSelection(length - 1, 0)},1);
    }
    justUpdatedFromParent.current = false;
  }
}, [showHTML, htmlContent]);

// Handle changes from user typing
const handleChange = (content) => {
  if (content !== htmlContent) {
    setHtmlContent(content);
    onChange?.(content?.replaceAll("<p><br></p>","<p></p>"));
  }
};

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 0' }}>
        <button
            onClick={() => {
                    if (!showHTML) {
                      // when switching to HTML mode, beautify it
                      const tidyhtml = beautifyHtml(htmlContent.replaceAll("<p><br></p>","<p></p>"), { indent_size: 2 })
                      console.log(tidyhtml)
                      setHtmlContent(tidyhtml);
                    }
                    setShowHTML((prev) => !prev);
                }}
                type="button"

                className='btns'
                >
                {showHTML ? '🔙 Editor' : '<> / HTML'}
        </button>
      </div>

      {!showHTML ? (
        <ReactQuill
          ref={quillRef}
          value={htmlContent}
          onChange={handleChange}
          modules={modules}
          theme="snow"
          style={{ height: '450px', overflowY: 'scroll', overflowX: 'hidden', display: showHTML ? 'none' : 'block' }}
        />
      ) : (
        <textarea
          value={htmlContent}
          onChange={(e) => setHtmlContent(e.target.value?.replaceAll("<p><br></p>","<p></p>"))}
          style={{ width: '100%', height: '430px', fontFamily: 'monospace', border: '1px solid #ccc' }}
        />
      )}
    </div>
  );
};

export default QuillEmailEditor;
